export const sectionColours = {
  "Black Glass": "section-img-glass-black",
  Blue: "section-blue",
  "Dark Blue": "section-darkerblue",
  "Dark pink": "section-darkerpink",
  Orange: "section-orange",
  "Dark Orange": "section-darkerorange",
  Green: "section-green",
  "Dark Green": "section-darkergreen",
  Red: "section-red",
  "Dark red": "section-darkerred",
  Grey: "section-grey",
  Black: "section-black",
  "Blue (Style 1)": "section-img-chev-blue",
  "Dark blue (Style 1)": "section-img-chev-darkerblue",
  "Navy (Style 1)": "section-img-chev-navy",
  "Pink (Style 1)": "section-img-chev-pink",
  "Dark Pink (Style 1)": "section-img-chev-darkerpink",
  "Orange (Style 1)": "section-img-chev-orange",
  "Dark Orange (Style 1)": "section-img-chev-darkerorange",
  "Green (Style 1)": "section-img-chev-green",
  "Dark Green (Style 1)": "section-img-chev-darkergreen",
  "Red (Style 1)": "section-img-chev-red",
  "Dark Red (Style 1)": "section-img-chev-darkerred",
  "Grey (Style 1)": "section-img-chev-grey",
  "Black (Style 1)": "section-img-chev-black",
  "Silver (Style 1)": "section-img-chev-silver",
  "Steel (Style 1)": "section-img-chev-steel",
  "Blue (Style 2)": "section-img-cross-blue",
  "Dark Blue (Style 2)": "section-img-cross-darkerblue",
  "Navy (Style 2)": "section-img-cross-navy",
  "Pink (Style 2)": "section-img-cross-pink",
  "Dark Pink (Style 2)": "section-img-cross-darkerpink",
  "Orange (Style 2)": "section-img-cross-orange",
  "Dark Orange (Style 2)": "section-img-cross-darkerorange",
  "Green (Style 2)": "section-img-cross-green",
  "Dark Green (Style 2)": "section-img-cross-darkergreen",
  "Red (Style 2)": "section-img-cross-red",
  "Dark Red (Style 2)": "section-img-cross-darkerred",
  "Grey (Style 2)": "section-img-cross-grey",
  "Black (Style 2)": "section-img-cross-black",
  "Silver (Style 2)": "section-img-cross-silver",
  "Steel (Style 2)": "section-img-cross-steel",
};

export const themeColours = {
  Blue: "theme-blue",
  Pink: "theme-pink",
  Orange: "theme-orange",
  Green: "theme-green",
  Red: "theme-red",
  Grey: "theme-grey",
  Navy: "theme-navy",
  "Dark Blue": "theme-darkerblue",
  "Dark Pink": "theme-darkerpink",
  "Dark Orange": "theme-darkerorange",
  "Dark Green": "theme-darkergreen",
  "Dark Red": "theme-darkerred",
  Black: "theme-black",
  "Bright Green": "theme-ninegreen",
  "Bright Orange": "theme-nineorange",
  "Bright Pink": "theme-hmvpink",
};
export const headerColours = {
  White: "head-white",
  Blue: "head-blue",
  Pink: "head-pink",
  Orange: "head-orange",
  Green: "head-green",
  Red: "head-red",
  "Dark Blue": "head-darkerblue",
  "Dark Pink": "head-darkerpink",
  "Dark Orange": "head-darkerorange",
  "Dark Green": "head-darkergreen",
  "Dark Red": "head-darkerred",
  grey: "head-grey",
  black: "head-black",
  "Very Black": "head-totalblack",
  Clouds: "head-clouds",
  Pixel: "head-pixel",
  "Dark Wave": "head-darkerwave",
  Wave: "head-darkwave",
  "Light Wave": "head-whitewave",
  Grass: "head-grass",
};
export const buttonColours = {
  "Bright Pink": "button-hmvpink",
  "Bright Orange": "button-nineorange",
  "Bright Green": "button-ninegreen",
  Blue: "button-blue",
  Navy: "button-navy",
  Pink: "button-pink",
  Green: "button-green",
  Red: "button-red",
  "Dark Blue": "button-darkerblue",
  "Dark Pink": "button-darkerpink",
  "Dark Orange": "button-darkerorange",
  "Dark Green": "button-darkergreen",
  "Dark Red": "button-darkerred",
  Grey: "button-grey",
  Black: "button-darkerblack",
};
export const navigationColours = {
  "Very Light Grey": "nav-lightergrey",
  "Light Grey": "nav-lightgrey",
  "Mid Grey": "nav-midgrey",
  "Dark  Grey": "nav-darkergrey",
  Black: "nav-black",
  "Lighter Grey (with background)": "nav-img-lightergrey",
  "Light Grey (with background)": "nav-img-lightgrey",
  "Mid Grey (with background)": "nav-img-midgrey",
  "Dark Grey (with background)": "nav-img-darkgrey",
  "Dark  Grey (with background)": "nav-img-darkergrey",
};

export const themeConstants = {
  "theme-blue.css": "2baee5",
  "theme-pink.css": "FA329E",
  "theme-orange.css": "FE6600",
  "theme-green.css": "46A202",
  "theme-red.css": "F70404",
  "theme-grey.css": "4A4A4A",
  "theme-navy.css": "0e3d78",
  "theme-darkerblue.css": "3B819E",
  "theme-darkerpink.css": "C25D93",
  "theme-darkerorange.css": "D55421",
  "theme-darkergreen.css": "59843A",
  "theme-darkerred.css": "B83939",
  "theme-black.css": "191919",
  "theme-ninegreen.css": "AAAAAA",
  "theme-nineorange.css": "AAAAAA",
  "theme-hmvpink.css": "AAAAAA",
};

export default () => {};
